import { createFileRoute } from "@tanstack/react-router";
import { VehicleDetailPage } from "@/features/vehicles/pages/vehicle-detail-page";

export const Route = createFileRoute("/_authenticated/vehicles/$vehicleId")({
	component: VehicleDetailPage,
});
